import React , {useEffect, useRef, useState} from 'react'; 
import '../assets/css/custom.css'; 
import '../assets/css/client.css'; 
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import {
    faEdit,
    faPlus,
    faSort,
    faTrash,
    faPenToSquare,
    faTimes,
    faTowerBroadcast,
    faScrewdriver,
    faScrewdriverWrench,
    faMessage,
    faPodcast,
  } from "@fortawesome/free-solid-svg-icons";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import ReactDOM from "react-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { Stepper, Step, StepLabel } from '@mui/material';
import { Textarea } from '@material-tailwind/react';
import { Circle } from '@mui/icons-material';
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import Menus from "./menus";
import Multiselect from 'multiselect-react-dropdown';
import Action from '../assets/img/Action.png';
import BroadCastImg from '../assets/img/megaphones.png';
import chat from '../assets/img/sent.png';
import ChatBubbleIcon from '../assets/img/chat.png';
import JoditEditor from 'jodit-react';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import FlatIcon from '../assets/img/config-flat.png';
import vehicleApproval from '../assets/img/vehicleapproval.png';
import noPictures from '../assets/img/no-pictures.png';


  function VehicleApproval() {
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Step 1', 'Step 2', 'Step 3'];
    const [Show, setShow] = useState(false);
    const [ApproveShow, setApproveShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [VehiclePendingList, setVehiclePendingList] = useState("");
    const [TowerListGet, setTowerListGet] = useState("");
    const [FlatListGet, setFlatListGet] = useState("");
    const [NoticeSubject, setNoticeSubject] = useState("");
    const [NoticeDescription, setNoticeDescription] = useState("");
    const [Importance, setImportance] = useState();
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [NoticeStatus, setNoticeStatus] = useState();
    const [NoticeTypeText, setNoticeTypeText] = useState("");
    const [NoticeId,setNoticeId] = useState("");
    const [firstSectionButton,setFirstSectionButton] = useState(false);
    const [CurrentStatusSelected,setCurrentStatusSelected] = useState("PENDING");
    const [UserData, setUserData] = useState("");
    const [TowerSelected, setTowerSelected] = useState([]);
    const [FlatSelected, setFlatSelected] = useState([]);
    const [Tower, setTower] = useState("");
    const [Flat, setFlat] = useState("");
    const [VehicleImages, setVehicleImages] = useState("");
    const [VehicleNumber, setVehicleNumber] = useState("");
    const [OwnerName, setOwnerName] = useState("");
    const [TagId, setTagId] = useState("");
    const [VehicleType, setVehicleType] = useState("");
    const [FuelType, setFuelType] = useState("");
    const [Brand, setBrand] = useState("");
    const [VehicleId, setVehicleId] = useState("");
    const [ApproverComment, setApproverComment] = useState([]);
    const [ApproverCommentInput, setApproverCommentInput] = useState("");
    const [CommentShowHide, setCommentShowHide ] = useState(false);
    const [SearchUser, setSearchUser] = useState("");
    const [OldVehicleData, setOldVehicleData] = useState("");

    const [fullscreen, setFullscreen] = useState(true);
    const editor = useRef(null);
    const [content, setContent] = useState('');

    useEffect(() => {
        if(ApproverCommentInput.length == 0){
            setCommentShowHide(false);
        }else{
            setCommentShowHide(true);
        }
    }, [ApproverCommentInput])  

    const convertISTTime = (date) => {
        if(date != null || date != "" || date != undefined ){
            const [datePart, TimePart] = date.split(" ");
            const [mm, dd, yyyy ] = datePart.split("/");
            // const [hh, mn, ss] = TimePart.split(':')
            const formatedTime = `${dd}-${mm}-${yyyy}`;
            return formatedTime;
        }else{
            console.warn("input date string may be null, empty string or undefined");
        }
    }

    const convertISSet = (date) => {
        if(date != null || date != "" || date != undefined ){
            let [datePart, TimePart] = date.split(" ");
            let [mm, dd, yyyy ] = datePart.split("/");
            // const [hh, mn, ss] = TimePart.split(':')
            // if(mm<10){mm.padStart(2, "0")};
            // if(dd<10){dd.padStart(2, "0")};
            if(mm<10){
               mm = "0"+mm
            }
            if(dd<10){
               dd = "0"+dd
            }
            const formatedTime = `${yyyy}-${mm}-${dd}`;
            return formatedTime;
        }else{
            console.warn("input date string may be null, empty string or undefined");
        }
    }

   
    
    const GetPendingVehicleList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        console.log("myuserData", myUserData)
        const bodyData = { 
            "currentStatus": CurrentStatusSelected,
        };
        try {
            setLoading(true);
            const endPointVariableKey = {
                // urlVariable:CurrentStatusSelected,
                buildingId: myUserData?.buildingId
            }
            // let response = await commonAPI("PendingResVehicle", undefined, endPointVariableKey)
            let response = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
            // console.log("Notice List", response?.data)
            if (response?.success === true){
                console.log("VehicleList====================", response)
                setVehiclePendingList(response?.data);
                setOldVehicleData(response?.data);
                setLoading(false);
            }else{
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber, // Need to be change
                "requestJSON": "",
                "uri": "/api/Master/Notice",
                "errorNumber": "PV01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "VehicleApproval.js",
                "functionName": "GetPendingVehicleList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response?.success === true && response?.message?.length == null){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }

    }

    useEffect(() => {
        GetPendingVehicleList();
    }, [CurrentStatusSelected])

    // function filterVehicleData(text) {
    //     setSearchUser(text)
    //     //console.log(filterImg)
    //     const oldData = VehiclePendingList
    //     // console.log(oldLogo,"LOGO")
    //     console.log(text.toLowerCase())
    //     let newData = OldVehicleData?.filter(item => {
          
    //         // Check if the search text exists in any property of the object
    //         return Object?.values(item).some(value =>
    //             value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
    //         );
    //     });
    //     setVehiclePendingList(newData)
    //     // console.log(logo)
    // }

    function filterVehicleData(text) {
        setSearchUser(text);
    
        const newData = OldVehicleData?.filter(item => {
             // Combine towerName and flatName with a dash
             const towerFlatCombined = `${item?.towerName}-${item?.flatName}`;
             // Convert tagSerialNumber to a string to allow text comparison
             const tagSerialNumber = item?.tagSerialNumber ? item?.tagSerialNumber.toString() : '';
            return (
                item?.lpNumber?.toLowerCase().includes(text?.toLowerCase()) ||
                towerFlatCombined.toLowerCase().includes(text?.toLowerCase()) ||
                item?.ownerName?.toLowerCase().includes(text?.toLowerCase()) ||
                tagSerialNumber.includes(text)  // Search tagSerialNumber (it's a number)
            );
        });
    
        setVehiclePendingList(newData);
    }

    

    const GetVehicleImages = async () => {
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
        const endPointVariableKey    = {
            urlVariable: VehicleId,
            buildingId: myUserData?.buildingId
        }
        try {
            setLoading(true);
            let response = await commonAPI("ResidentVehicleDoc", undefined, endPointVariableKey)
            if (response?.success===true && response?.message?.length == 0){
                console.log("Vehicle Get Images", response)
                setVehicleImages(response?.data)
                setLoading(false);
            }else{
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber, // Need to be change
                "requestJSON": null,
                "uri": "/api/Master/Notice/Images",
                "errorNumber": "NI01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeImages",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response?.success === true && response?.message?.length == 0){
                toast.error("Something went wrong ");
                setLoading(false); 
            }else{
                toast.error("Something went wrong ");
                setLoading(false); 
            }
        }

    }

    useEffect(() => {
        if(VehicleId){
            GetVehicleImages();
        }    
    }, [VehicleId])    

    const GetPublishList = async () => {
        try {
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            console.log("myuserData", myUserData)
            const endPointVariableKey = {
                urlVariable:NoticeId,
                buildingId: myUserData.buildingId
            }
            let response = await commonAPI("NoticeRecipient", undefined, endPointVariableKey)
            console.log("Notice Recipient List", response?.data)
            if (response?.success === true){
                // console.log("Notice Recipient", response);
                const selectedTowers = [];
                const noticeRecipientTransitData = response?.data?.noticeRecipientTransitData;
                // console.log("selected=================", TowerListGet);
                
                for(var k=0;k<noticeRecipientTransitData.length;k++){
                    for(var l=0;l<TowerListGet.length;l++){
                        if(noticeRecipientTransitData[k].towerId ==  TowerListGet[l].towerId){
                            var exists=false;
                            for(var m=0;m<selectedTowers.length;m++){
                                if(selectedTowers[m].towerName==TowerListGet[l].towerName){
                                    exists=true;
                                    break;
                                }
                            }
                            if(exists==false){
                                const selectedTowersObj={};
                                selectedTowersObj.towerId = noticeRecipientTransitData[k].towerId ;
                                selectedTowersObj.towerName = TowerListGet[l].towerName ;
                                selectedTowers.push(selectedTowersObj);
                            }
                            break;
                        }
                    }
                }
                // console.log("selected=================", noticeRecipientTransitData,  selectedTowers, TowerListGet);
                const tempData = selectedTowers?.map((item) => {return {value: item?.towerId, label: item?.towerName}});

                const selectedFlat = [];
                setTowerSelected(tempData);
                console.log("selected=================", tempData);
                
                for(var k=0;k<noticeRecipientTransitData.length;k++){
                    for(var l=0;l<FlatListGet.length;l++){
                        if(noticeRecipientTransitData[k].flatId ==  FlatListGet[l].flatId){
                            var exists=false;
                            for(var m=0;m<selectedFlat.length;m++){
                                if(selectedFlat[m].flatName==FlatListGet[l].flatName){
                                    exists=true;
                                    break;
                                }
                            }
                            if(exists==false){
                                const selectedFlatObj={};
                                selectedFlatObj.flatId = noticeRecipientTransitData[k].flatId ;
                                selectedFlatObj.flatName = FlatListGet[l].flatName ;
                                selectedFlat.push(selectedFlatObj);
                            }
                            break;
                        }
                    }
                }
                console.log("selected=================", noticeRecipientTransitData,  selectedFlat, selectedFlat);
                const tempDataFlat = selectedFlat?.map((item) => {return {value: item.flatId, label: item.flatName, towerId: item?.towerId}});
                setFlatSelected(tempDataFlat);
                
                
                
                
                

                
            }else{
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber, // Need to be change
                "requestJSON": "",
                "uri": "/api/Master/Notice",
                "errorNumber": "NL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response?.success === true & response?.message?.length == null){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }

    }

    // useEffect(() => {
    //     if (VehicleId){
    //         GetPublishList();
    //         // toast.error("publice Fuc Call");
    //     }
    // }, [VehicleId])
 

    const ApproveModal = (item) => {
        setApproveShow(true);
        console.log("itemApproveModal", item)
        setVehicleNumber(item?.lpNumber)
        setOwnerName(item?.ownerName)
        setTagId(item?.tagId)
        setVehicleType(item?.vehicleType)
        setFuelType(item?.fuelType)
        setBrand(item?.brand)
        setVehicleId(item?.vehicleId)
        const approverComment = item?.approverComment.split("\r\n")
        console.log("approverComment", approverComment)
        setApproverComment(approverComment)
        setApproverCommentInput("")
        setTower(item?.towerName)
        setFlat(item?.flatName)
    }

    const ApproveAPi = async(e) => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const endPointVariableKey = {
            urlVariable:null,
            buildingId: myUserData.buildingId
        }
        setApproveShow(true);
        console.log("e value", e)
        const bodydata = { 
            "vehicleId": VehicleId,
            "CurrentStatus": e,
            "ApproverComment": ApproverCommentInput,
            "ApproverUserName": myUserData.userName,
            "modifiedUserId": myUserData?.userId?.toString()
          };
        try {
            setLoading(true);
            if(!ApproverCommentInput){
                toast.warning("Please enter Comment"); 
                setLoading(false);
            }else{
                console.log("body", bodydata);
                let response = await commonAPI("ApproveResidentVehicle", bodydata, endPointVariableKey)
                //   const response = await fetch(`http://api-test.curonext.com/api/Master/Building/`, {
                //     // let response = await fetch(`${apiURL}/DAR/DARReportToHOD`, {  
                //       method: "DELETE",
                //       headers: { 'Content-Type': 'application/json'},
                //       body: bodydata
                    
                //   })
                //   const statusCode = response
                console.log("VehicleNotice", response)
                if(response?.success === true && response?.message.length == 0){
                    
                    // setApproveShow(false);
                    if(e == "PENDING"){
                        setLoading(false);
                        const bodyData = { 
                            "currentStatus": CurrentStatusSelected,
                        };
                        const endPointVariableKey = {
                            // urlVariable:CurrentStatusSelected,
                            buildingId: myUserData.buildingId
                        }
                        // let responsePending = await commonAPI("PendingResVehicle", undefined, endPointVariableKey);
                        let responsePending = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
                        const tempData = responsePending?.data?.filter((item)=> item?.vehicleId == VehicleId)
                        console.log("tempData", tempData)
                        const approverComment = tempData[0]?.approverComment?.split("\r\n")
                        console.log("approverComment", approverComment)
                        setApproverComment(approverComment)
                        setApproverCommentInput("")
                        toast.success(`Comment Added`);
                        GetPendingVehicleList();
                        // toast.success(`Vehicle ${e}`);  
                    }else{
                        setLoading(false);
                        const bodyData = { 
                            "currentStatus": CurrentStatusSelected,
                        };
                        const endPointVariableKey = {
                            // urlVariable:CurrentStatusSelected,
                            buildingId: myUserData.buildingId
                        }
                        let responsePending = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey);
                        const tempData = responsePending?.data?.filter((item)=> item?.vehicleId == VehicleId)
                        console.log("tempData", tempData)
                        const approverComment = tempData[0]?.approverComment?.split("\r\n")
                        console.log("approverComment", approverComment)
                        setApproverComment(approverComment)
                        setApproverCommentInput("")
                        toast.success(`Vehicle Rejected`);  
                        setApproveShow(false);
                        GetPendingVehicleList();
                    }
                    

                }else{
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }    
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Vehicle/ApproveResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "VehicleApproval.js",
                "functionName": "ApproveAPi",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
            
        }
        
    }

    const ApprovedVehicle = async(e) => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const endPointVariableKey = {
            urlVariable:null,
            buildingId: myUserData.buildingId
        }
        setApproveShow(true);
        console.log("e value", e)
        const bodydata = { 
            "vehicleId": VehicleId,
            "CurrentStatus": "APPROVED",
            "ApproverComment": ApproverCommentInput,
            "ApproverUserName": myUserData.userName,
            "modifiedUserId": myUserData?.userId?.toString()
          };
        try {
            setLoading(true);
            
                console.log("body", bodydata);
                let response = await commonAPI("ApproveResidentVehicle", bodydata, endPointVariableKey)
                console.log("VehicleNotice", response)
                if(response?.success === true && response?.message.length == 0){
                    setLoading(false);
                    const bodyData = { 
                        "currentStatus": CurrentStatusSelected,
                    };
                    const endPointVariableKey = {
                        urlVariable:CurrentStatusSelected,
                        buildingId: myUserData.buildingId
                    }
                    let responsePending = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
                    const tempData = responsePending?.data?.filter((item)=> item?.vehicleId == VehicleId)
                    console.log("tempData", tempData)
                    const approverComment = tempData[0]?.approverComment?.split("\r\n")
                    console.log("approverComment", approverComment)
                    setApproverComment(approverComment)
                    setApproverCommentInput("")
                    toast.success(`Vehicle Approved`); 
                    setApproveShow(false);
                    GetPendingVehicleList();
                 
                }else{
                    toast.error(response.message[0]);
                    setLoading(false);
                } 
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Vehicle/ApproveResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "VehicleApproval.js",
                "functionName": "ApprovedVehicle",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
            
        }
        
    }

     useEffect(() => {
                const handleKeyDown = (event) => {
                    if (ApproverCommentInput) {
                        if (event.key === 'Enter') {
                            event.preventDefault();  // Prevent default form submission behavior
                            ApproveAPi("PENDING");  // Call Login function
                        }
                    }    
                };
            
                // Attach the event listener
                window.addEventListener('keydown', handleKeyDown);
            
                // Cleanup the event listener on component unmount
                return () => {
                    window.removeEventListener('keydown', handleKeyDown);
                };
        }, [ApproverCommentInput])
  
    const handleNext = () => {
       
        setActiveStep((prevActiveStep) => {
            if (prevActiveStep >= steps.length - 1) { // Assuming 'steps' is your array of step labels
                setFirstSectionButton(false)
                console.log(prevActiveStep)
                return 0; // Reset to first step
            } else {
                // console.log(inpRef.current.value)
                setFirstSectionButton(true)
                console.log(prevActiveStep)
                 return prevActiveStep + 1;
                
            }
        });
    };
  
    const handleBack = () => {
        
        setFirstSectionButton(false)
      setActiveStep((prevActiveStep) => {
        if(prevActiveStep==1){
            setFirstSectionButton(false)
            console.log(prevActiveStep)
            return prevActiveStep - 1
        }
        else{
            setFirstSectionButton(true)
            return prevActiveStep - 1
        }
       
    });
    };

    



    const [file, setFile] = useState();
    function handleChange(e) {
        console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
    }


     return (
    <>
    {Loading? 
        <div className="loaderDiv">
            <div className="loader"></div>
        </div> 
    :null}
    <ToastContainer />
    {/* <Menus /> */}
    <section id="client-builder">
   <div className="container-fluid pt-2">
   <div className="row mb-3 mt-5 pt-2" style={{alignItem:'center'}}>
            <div className="col-lg-6 col-md-6 px-0 ">
                <div className="HeadingTop">
                    <h3> Vehicle Approval </h3>
                    <span> Review and verify for new vehicle {CurrentStatusSelected.charAt(0).toLowerCase() + CurrentStatusSelected.slice(1).toLowerCase()}.</span>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 px-0  text-right" style={{alignContent:'center'}}>
            <input type="text" className="onlysearch" style={{padding: "7px 40px 5px 10px", marginRight: 10}} value={SearchUser} placeholder='Search' onChange={(e) => filterVehicleData(e.target.value)} />
              <select size="md" className="sltareamodal col-4 ml-auto bg-white"  onChange={(e) => {
                            console.log("selection", e.target.value)
                            setCurrentStatusSelected(e.target.value);
                        }
                            }>
                <option value="PENDING">Pending</option>
                <option value="APPROVED">Approved</option>
                <option value="REJECTED">Rejected</option>
              </select>
            </div>
        </div>
      
      {/*  BroadCast Modal */}
      <Modal fullscreen={fullscreen}  show={Show} onHide={() =>
         setShow(false)} className="modal-100w  modal-fullscreen" aria-labelledby="example-custom-modal-styling-title">
         <Modal.Header className="headerMDL" closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
               Approve Notice
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
         <div className="row">
                            <div className="col-lg-5 col-md-5 col-sm-12 col-12">
                                <div className="row">
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-3 px-0">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Notice Type {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <input type="text" className="form-control required" disabled value={NoticeTypeText} onChange={(e) => {setNoticeTypeText(e.target.value);}}/>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-3 px-0">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Importance {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <input type="text" className="form-control required" disabled value={Importance} onChange={(e) => {setImportance(e.target.value);}}/>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Effective Start Date {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <input type="date" className="form-control required" disabled value={StartDate} onChange={(e) => {setStartDate(e.target.value);}}/>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Effective End Date {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <input type="date" className="form-control required" disabled value={EndDate} onChange={(e) => {setEndDate(e.target.value);}}/>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Notice Subject {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control required"
                                                id="wfirstName2"
                                                name="firstName"
                                                aria-required="true"
                                                value={NoticeSubject} disabled onChange={(e) => {setNoticeSubject(e.target.value);}}/>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                        <div className="form-group">
                                            <label for="wfirstName2" style={{fontSize: "small"}}>
                                            {" "}
                                            Notice Description {" "}
                                            {/* <span className="danger">*</span>{" "} */}
                                            </label>
                                            <JoditEditor ref={editor} value={content} tabIndex={1} onBlur={newContent =>
                                                    setContent(newContent)}/>
                                        </div>
                                    </div>  
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 col-12 px-0">
                                <div className="uploadedfilesection" style={{border: "1px solid #dadada"}}>
                                    <span className='modalImageheader'>Images</span>
                                <ul style={{marginTop: "60px"}}>
                                {/* {NoticeImages ? NoticeImages?.map((item, index) =>
                                    <li key={index} >
                                        <img src={atob(item?.docImage)} className="img img-responsive" />
                                    </li>
                                ):null}     */}
                                </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12 px-0">
                                <div className="form-group bg-white" >
                                    <div className='' style={{border: "1px solid #dadada", padding: "10px"}}>
                                        <span style={{fontSize: "12px"}}> BroadCast Message</span>
                                    </div>

                                    <div className="uploadedfilesection" style={{height: "390px"}}>
                                    <div className="card-body row">  
                                    </div>
                                    <div className='row mb-5 mt-3'>
                                        <div className='col-md-6 text-center'>
                                            {/* <button value={"APPROVED"} onClick={() => (BroadCast())} className='col-9 btn btn-info'>BroadCast</button> */}
                                        </div>    
                                    </div>                
                                    </div>
                                </div>
                            </div>
                           
                        </div>
         </Modal.Body>
         <div class="fixed_allbtn">
            <div class="upload_btn">
                <div class="  align-self-start">
                    <div class="  text-left mt-3">
                         
                        </div>
                        </div>
                        </div>
                        </div>
      </Modal>

      {/*  Approve/Reject Modal */}
      <Modal fullscreen={fullscreen}  show={ApproveShow} onHide={() =>
         setApproveShow(false)} className="modal-100w  modal-fullscreen" aria-labelledby="example-custom-modal-styling-title">
         <Modal.Header className="headerMDL" closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
               Vehicle Approval
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <div className="row" id="validation">
                <div className="col-12">
                    <form
                    action="#"
                    className="validation-wizard wizard-circle wizard clearfix"
                    role="application"
                    id="steps-uid-0"
                    novalidate="novalidate"
                    >
                        <div className="row">
                            <div className="col-lg-5 col-md-5 col-sm-12 col-12">
                                <div className="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Vehicle Number {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input type="text" className="form-control required" disabled value={VehicleNumber} />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Owner Name {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input type="text" className="form-control required" disabled value={OwnerName} />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Tag Id {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input type="text" className="form-control required" disabled value={TagId} />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Flat Number {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input type="text" className="form-control required" disabled value={`${Tower} - ${Flat}`}/>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Vehicle Type {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input type="text" className="form-control required" disabled value={VehicleType}/>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Fuel Type {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control required"
                                            id="wfirstName2"
                                            name="firstName"
                                            aria-required="true"
                                            value={FuelType} disabled/>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                    <div className="form-group">
                                        <label for="wfirstName2">
                                        {" "}
                                        Brand {" "}
                                        {/* <span className="danger">*</span>{" "} */}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control required"
                                            id="wfirstName2"
                                            name="firstName"
                                            aria-required="true"
                                            value={Brand} disabled/>
                                    </div>
                                </div>  
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 col-12 px-0">
                                <div className="uploadedfilesection" style={{border: "1px solid #dadada"}}>
                                    <span className='modalImageheader'>Images</span>
                                <ul style={{marginTop: "60px"}}>
                                {VehicleImages ? VehicleImages?.map((item, index) =>
                                    <li key={index} >
                                        {/* <div className='RelativeDel'>
                                            <FontAwesomeIcon icon={faTimes} onClick={() => ShowDeleteImgModal(item)} className="deleteupload" />
                                        </div> */}
                                        <h5>{item?.docName}</h5>
                                        <img src={item?.docImage} className="img img-responsive" />
                                        
                                    </li>
                                ):null}  
                                {!VehicleImages?.length ? (VehicleImages?.length == 0 && VehicleImages?.length != null &&
                                    <div className='bg-white' style={{ paddingBottom:"50px", borderRadius: "10px" }}>
                                        <div className='col-12 text-center'>
                                            <img src={noPictures} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                                        </div>
                                        <br />
                                        <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No Image Found</h3>
                                        {/* <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a Notice</h5> */}
                                    </div>) : null}  
                                </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12 px-0">
                                <div className="form-group bg-white" >
                                    <div className='' style={{border: "1px solid #dadada", padding: "10px"}}>
                                        <span style={{fontSize: "12px"}}>Comments</span>
                                    </div>

                                        <div className="uploadedfilesection" style={{height: "390px"}}>
                                        {ApproverComment?.map((item,index) =>
                                        <h6 className='mt-3' style={{wordWrap: "break-word"}}>{item}</h6>
                                        )}
                                        </div>
                                    

                                        
                                </div>
                            </div>
                            
                        </div>
                    </form>
                </div>
            </div>
         </Modal.Body>
         <div class="fixed_allbtn">
            <div class="upload_btn">
                <div class="  align-self-start">
                    <div class="  text-left mt-3">
                         
                    <div className='Notice_modal_comment'>
                    {CurrentStatusSelected == "REJECTED" ? 
                                <button type="button" className="btn border bg-white" onClick={() => setApproveShow(false)}> Cancel</button>:
                            <div className="comment_Sec">
                                <input
                                    type="text"
                                    className="form-control required border-0"
                                    id="wfirstName2"
                                    name="firstName"
                                    aria-required="true"
                                    placeholder='Add comment here'
                                    value={ApproverCommentInput}
                                    onChange={(e) => setApproverCommentInput(e.target.value)}
                                    />
                            </div>
                    }
                            <div className='comment_btns'  >
                            {/* <Button className='btn btn-default p-0'> */}
                                    {/* <FontAwesomeIcon className="editNotice" icon={faMessage} style={{fontSize:"20px"}}/> */}
                                {/* </Button> */}
                                {/* <img src={chat} alt="homepage" className="dark-logo" value={"PENDING"} onClick={(e) => (ApproveAPi(e.target.value))} style={{width: "19%", paddingRight: 20}}/>  */}
                                {/* <img src={chat} alt="homepage" className="dark-logo" style={{width: "19%", paddingRight: 20}}/>
                                <Button value={"PENDING"} onClick={(e) => (ApproveAPi(e.target.value))}  className=" border-0 m-0" id="webUrl3" name="webUrl3" aria-required="true" style={{backgroundColor: "transparent", position: "absolute", padding: "20px", boxShadow: "none", left: "265px"}}>
                                        {" "}
                                        
                                </Button> */}
                                {CurrentStatusSelected == "REJECTED" ? 
                                    null :
                                    <>
                                        {CommentShowHide ?
                                        <div style={{position: "relative", top: '0px' }}> 
                                            <img src={chat} alt="homepage" className="dark-logo" style={{width: "77%", paddingRight: '7px'}}/>
                                            <Button value={"PENDING"} onClick={(e) => (ApproveAPi(e.target.value))}  className=" border-0 m-0" id="webUrl3" name="webUrl3" aria-required="true" style={{backgroundColor: "transparent", position: "absolute", padding: "20px", boxShadow: "none", right: "25px", top: "-5px"}}>
                                                    {" "}
                                                    
                                            </Button>
                                        </div>
                                        :null}
                                        {!CommentShowHide ? 
                                            <div style={{position: "relative", top: '0px' }}> 
                                                <img src={ChatBubbleIcon} alt="homepage" className="dark-logo" style={{width: "77%", paddingRight: '7px'}}/>
                                                <Button value={"PENDING"} onClick={(e) => (ApproveAPi(e.target.value))}  className=" border-0 m-0" id="webUrl3" name="webUrl3" aria-required="true" style={{backgroundColor: "transparent", position: "absolute", padding: "20px", boxShadow: "none", right: "25px", top: "-5px"}}>
                                                        {" "}
                                                        
                                                </Button>
                                            </div>
                                        :null}    
                                     </>}   
                                {/* <div style={{position: "relative", top: '0px' }}> 
                                    <img src={chat} alt="homepage" className="dark-logo" style={{width: "77%", paddingRight: '7px'}}/>
                                    <Button value={"PENDING"} onClick={(e) => (ApproveAPi(e.target.value))}  className=" border-0 m-0" id="webUrl3" name="webUrl3" aria-required="true" style={{backgroundColor: "transparent", position: "absolute", padding: "20px", boxShadow: "none", right: "25px", top: "-5px"}}>
                                            {" "}
                                            
                                    </Button>
                                </div>
                                */}
                                {CurrentStatusSelected == "REJECTED" ? 
                                null :
                                <div className="cmt-btn">
                                    
                                    <Button value={"APPROVED"} onClick={(e) => (ApprovedVehicle())}  className="bg-success form-control notice-comment m-0" id="webUrl3" name="webUrl3" aria-required="true" >
                                        {" "}
                                        Approve
                                    </Button>
                                    <Button value={"REJECTED"} onClick={(e) => (ApproveAPi(e.target.value))}  className="bg-danger form-control notice-comment m-0" id="webUrl3" name="webUrl3" aria-required="true" >
                                        {" "}
                                        Reject
                                    </Button>
                                </div>
                                }
                    </div>
                </div>

                        </div>
                        </div>
                        </div>
                        </div>
      </Modal>
      
      
      <div className='row'>
        {VehiclePendingList ? VehiclePendingList.map((item, index) =>  
        <div key={index} className="OneTile">
            <div className="ex_feild">
                {item?.currentStatus.toUpperCase() == "PENDING" ?
                    <span className="imp_med"> </span>
                :null}

                {item?.currentStatus.toUpperCase() == "REJECTED" ?
                    <span className="imp_high"> </span>
                :null}

                {item?.currentStatus.toUpperCase() == "APPROVED" ?
                    <span className="imp_Low"> </span>
                :null}
            </div>
            <div className="NoticeFeild">
                <div className='d-flex' style={{justifyContent: "space-between", alignItems: "end"}}>
                    <h1> {item?.lpNumber}</h1>
                    <span> {item.currentStatus} </span>
                </div>    
                <h2> {item?.ownerName} </h2>

                <div className="onboardFlex w-100" style={{justifyContent: "space-between"}}>
                    {/* <h4> Current Status </h4> */}
                    <div className='d-flex'>
                        <h4> Flat No </h4>
                        <span> {item.towerName} - {item.flatName} </span>
                    </div>    
                </div><br/>
                <div className="onboardFlex">
                    <h4> Tag S.No. </h4>
                    <label> {item?.tagSerialNumber} </label>

  
                {/* {item?.currentStatus?.toUpperCase() == "APPROVED" ? 
                    <div className="onboardFont" style={{marginLeft: "20px"}}>
                        <img src={BroadCastImg} onClick={() => BroadCastModal(item)} alt="homepage" className="dark-logo" style={{width: "45%", marginTop: "-10px"}}/> 
                    </div>
                    :null
                } */}
                </div>
                {item?.currentStatus?.toUpperCase() == "PENDING" || item?.currentStatus?.toUpperCase() == "REJECTED" ? 
                     <div class="bars_font">
                     <h3
                       className="font_trigger"
                       onClick={() => ApproveModal(item)}>
                       <FontAwesomeIcon icon={faPodcast} />
                     </h3>
                     </div>   
                   
                    :null
                }  
            </div>
        </div>
        ): null} 
        {VehiclePendingList?.length == 0 ? (!VehiclePendingList?.length &&  VehiclePendingList?.length != null && 
        <div className='bg-white' style={{height: "300px", borderRadius: "10px"}}>
            <div className='col-12 text-center'>
                <img src={vehicleApproval} alt="user" class="mx-auto mt-5" style={{height: "150px"}} />
            </div>    
            <br />
            <h3 className='col-12 text-center' style={{marginTop: "0px"}}> No Vehicle Found</h3>
            {/* <h5 className='col-12 text-center' style={{marginTop: "10px"}}> Click on Create New button to add a Notice</h5> */}
        </div>) :null} 
    </div>
   </div>
</section> 
        </>)

} 
  export default VehicleApproval 